import { render, staticRenderFns } from "./EditExerciseSentenceStress.vue?vue&type=template&id=9a69e104&"
import script from "./EditExerciseSentenceStress.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseSentenceStress.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseSentenceStress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports